import Vue from 'vue'

export default {
  apiPrefix: '/api/v2/sites',
  updatePartitionArmingScheduleEnabled: function ({siteId, partitionId, armingScheduleEnabled}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/partitions/${partitionId}`
    let data = {
      arming_schedule_enabled: armingScheduleEnabled, // 0=disabled, 1=enabled
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader())
  },
  getPartitionArmingSchedules: function ({siteId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/partitions-arming-schedules`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
  createPartitionArmingSchedule: function ({siteId, partitionId, scheduleArray}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/partitions/${partitionId}/arming-schedules`
    let data = scheduleArray
    return Vue.http.post(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader())
  },
  updatePartitionArmingSchedule: function ({siteId, partitionId, scheduleId, time}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/partitions/${partitionId}/arming-schedules/${scheduleId}`
    let data = {
      start_time: time
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, Vue.auth.getBearerHeader())
  },
  deletePartitionArmingSchedule: function ({siteId, partitionId, scheduleId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/partitions/${partitionId}/arming-schedules/${scheduleId}`
    return Vue.http.delete(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
}
